import React from 'react';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { stateValueFormatter, warrantStateValueFormatter } from 'utils/valueFormatters';
import { IconCycle } from 'utils/icons';
import NotApplicableCellRenderer from 'components/NotApplicableCellRenderer';
import './warrant-state-cell-renderer.scss';

type Props = {
  value?: string,
  node?: { group: boolean }
};

export default function WarrantStateCellRenderer({
  value,
  node,
  ...rest
}: Props): JSX.Element {
  if (node?.group) {
    return <span />;
  }

  if (value == null || value === '-' || value === '') {
    return (
      <NotApplicableCellRenderer />
    );
  }

  let className = 'status warrant-';

  if (value === 'ACTIVE') {
    className += 'active';
  } else if (value === 'TRASH') {
    className += 'trash';
  } else if (value === 'PENDING') {
    className += 'pending';
  } else if (value === 'EXPIRED') {
    className += 'expired';
  } else if (value === 'STOPPED') {
    className += 'stopped';
  } else if (value === 'PAUSED') {
    className += 'paused';
  } else if (value === 'MIXED') {
    className += 'mixed';
  }

  value = warrantStateValueFormatter({ ...(rest as ICellRendererParams), value });

  return (
    <span className="warrant-state-cell-renderer">
      <span className={className} title={value}><IconCycle /></span>
      {value}
    </span>
  );
}
